import { render, staticRenderFns } from "./FormNewParcel.vue?vue&type=template&id=3d9d516c&"
import script from "./FormNewParcel.vue?vue&type=script&lang=js&"
export * from "./FormNewParcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports